import React from 'react';
import ClickLabel from '../Ui/ClickLabel';

interface IProps {
  readonly value: string;
}

const EnvironmentName: React.FC<IProps> = ({ value }) => {
  return (
    <ClickLabel
      label="Environment"
      title={value}
      value={value}
    />
  );
};

export default EnvironmentName;